export default __webpack_public_path__ + "static/media/stats.66bdc227.svg";